module.exports = __webpack_public_path__ + "components/about-header/static/header--huge-1622d9490d10fa4ce262e2d4b403bc75.jpg";